// extracted by mini-css-extract-plugin
export default {"FormGroup":"FormGroup_FormGroup__NGKXk","items":"FormGroup_items__fanjH","displayColumn":"FormGroup_displayColumn__3m9Nv"};